module.exports = __webpack_public_path__ + "static/media/wechat.5d3ee108.png";